import MarkdownIt from 'markdown-it';

const md = new MarkdownIt();

const isMarkdown = (content: string): boolean => {
  if (/<[a-z][\s\S]*>/i.test(content)) {
    return false;
  }

  return /[*_#\[\]`]/.test(content);
};

export const normalizeReportsSectionContent = (content: string): string => {
  return isMarkdown(content) ? md.render(content) : content;
};
